import { CardContent, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  sourcing: string | null
  companyName: string
}

const MenuItemSourcing: React.FC<Props> = ({ sourcing, companyName }) => {
  const { t } = useTranslation()
  return (
    <CardContent>
      <Stack spacing={3} direction="column">
        <Stack direction="row" spacing={1}>
          <Typography variant="subtitle3">
            {sourcing ? 'Sourcing' : 'There is no sourcing information yet'}
          </Typography>
          {sourcing ? (
            <Typography color="text.secondary" variant="body2">
              ({t('cc:allInformationProvidedBy')} {companyName})
            </Typography>
          ) : null}
        </Stack>
        {sourcing ? <Typography variant="subtitle3">{t('cc:ingredientSources')}</Typography> : null}
        <Typography variant="body1" color="text.secondary">
          {sourcing || `We are waiting for information to be supplied by ${companyName}`}
        </Typography>
      </Stack>
    </CardContent>
  )
}

export default MenuItemSourcing
